import { render, staticRenderFns } from "./ProdictConfigList.vue?vue&type=template&id=2594c35c&scoped=true"
import script from "./ProdictConfigList.vue?vue&type=script&lang=js"
export * from "./ProdictConfigList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2594c35c",
  null
  
)

export default component.exports